import React from 'react'
import withStyles from 'isomorphic-style-loader/withStyles'
import * as commonStyles from '../../../../../common/_common.scss'
import AdviserProfileClientPreferences from '../../../../../common/AdviserProfiles/AdviserProfileClientPreferences'
import * as styles from './_AdviserProfileClientTypesEditor.scss'
import { connect } from 'react-redux'
import { FormCheck } from 'react-bootstrap'
import {
  startEditingClientTypes
  , stopEditingClientTypes
  , cancelEditingClientTypes
  , fetchClientTypes
  , clientTypeSelectedChanged
} from './adviserProfileClientTypesEditorActions'
import { bindActionCreators } from 'redux'
import PropTypes from 'prop-types';

class adviserProfileClientTypesEditorActions extends React.Component {
  static propTypes = {
    profile: PropTypes.object.isRequired,
    editingClientTypes: PropTypes.bool.isRequired,
    loading: PropTypes.bool.isRequired,
    startEditingClientTypes: PropTypes.func.isRequired,
    stopEditingClientTypes: PropTypes.func.isRequired,
    cancelEditingClientTypes: PropTypes.func.isRequired,
    fetchClientTypes: PropTypes.func.isRequired,
    allClientTypes: PropTypes.array.isRequired,
    clientTypeSelectedChanged: PropTypes.func.isRequired,
    formIsValid: PropTypes.bool.isRequired,
    validationstate: PropTypes.object.isRequired,
    clientTypePreferenceModifications: PropTypes.array.isRequired
  };

  constructor (props) {
    super(props)
    this.stopEditingClientTypes = this.stopEditingClientTypes.bind(this)
  }

  componentDidMount () {
    this.props.fetchClientTypes()
  }

  stopEditingClientTypes () {
    this.props.stopEditingClientTypes()
  }

  render () {
    const profile = this.props.profile
    const editingClientTypes = this.props.editingClientTypes
    const selectedClientTypes = profile.clientTypePreferences

    if (editingClientTypes) {
const allClientTypes = this.props.allClientTypes.map(clientType => ({
  ...clientType,
  selected: selectedClientTypes.some(
    selectedClientType =>
      selectedClientType.clientTypeId === clientType.clientTypeId
  )
}))
      return <div>
        <h4 className={styles['title']}>I like working with the following client types</h4>
        <form className={styles['form-bottom-margin']}>
          {allClientTypes.map((clientType) => {
            return <FormCheck
              key={clientType.clientTypeId}
              type="checkbox"
              checked={clientType.selected}
              value={clientType.clientTypeId}
              onChange={() => {
                this.props.clientTypeSelectedChanged(clientType)
              }}
              label={clientType.description}
            />

          })}
        </form>
      </div>
    }

    return <div>
      <AdviserProfileClientPreferences clientPreferences={this.props.clientTypePreferenceModifications} />
    </div>
  }
}

const mapStateToProps = ({adviserProfileApprovalEditorContainer}) => {
  return {
    editingClientTypes: adviserProfileApprovalEditorContainer.clientTypes.editingClientTypes,
    loading: adviserProfileApprovalEditorContainer.clientTypes.loadingClientTypes,
    formIsValid: adviserProfileApprovalEditorContainer.clientTypes.isInvalid.formIsValid,
    validationstate: adviserProfileApprovalEditorContainer.clientTypes.isInvalid,
    allClientTypes: adviserProfileApprovalEditorContainer.clientTypes.allClientTypes,
    clientTypePreferenceModifications: adviserProfileApprovalEditorContainer.clientTypes.profileModifications
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    startEditingClientTypes: startEditingClientTypes,
    stopEditingClientTypes: stopEditingClientTypes,
    cancelEditingClientTypes: cancelEditingClientTypes,
    fetchClientTypes: fetchClientTypes,
    clientTypeSelectedChanged: clientTypeSelectedChanged
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)( (adviserProfileClientTypesEditorActions))
